import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { HeaderNavigation } from './HeaderNavigation';
import { MenuLargeNavigation } from './MenuLargeNavigation';
import { HeaderUserProfile } from './HeaderUserProfile';
import paths from '../../paths';
import routes from '../../routes';

export default class Header extends Component {

  getMappedNavList = ({ location }) => {
    const initialNavList = [
      {
        to: paths.advocates.education,
        section: 'Education',
        className: '-education',
        label: 'Обучение',
        active: false,
      },
      {
        to: paths.advocates.forum,
        section: 'Forum',
        className: '-forum',
        label: 'Форум',
        active: false,
      },
      {
        to: paths.advocates.gallery,
        section: 'Gallery',
        className: '-gallery',
        label: 'Галерея',
        active: false,
      },
      {
        to: paths.advocates.practice,
        section: 'Practice',
        className: '-practice',
        label: 'Практика',
        active: false,
      },
      {
        to: paths.advocates.news,
        section: 'News',
        className: '-news',
        label: 'Новости',
        active: false,
      }
    ];

    const navList = initialNavList.map((item) => {
      const currentRoute = routes.advocates.find(route => new RegExp(`^${route.path}(/|$)`).exec(location) !== null);
      if (currentRoute && currentRoute.section === item.section) {
        item.className += ' -active';
        item.active = true;
      }
      return item;
    });

    return navList;
  };


  render() {
    const navList = this.getMappedNavList({ location: this.props.location });
    return (
      <React.Fragment>
        <header className="header">
          <div className="header-main">
            <div className="btn-menu" onClick={this.props.toggleMenu}>
              Показать меню
            </div>

            <div className="header-logo" >
              <Link to={paths.advocates.main} className="CooperVison" onClick={this.props.hideMenu}>
                Cooper Vison
              </Link>
              <span className="company-name">Адвокаты бренда</span>
            </div>

            <HeaderNavigation navList={navList} />

            <div className="header-aside user-cell">
              <HeaderUserProfile {...this.props} />

              <a href={paths.common.signout} className="logout">
                <svg className="logout__icon" width="16" height="16">
                  <use xlinkHref="#logout" />
                </svg>
              </a>
            </div>
          </div>
        </header>
        <div className="menu-large">
          <div className="menu-large-main scrolling">
            <div className="menu-large-content">
              <span className="menu-large-title">Адвокаты бренда</span>

              <MenuLargeNavigation navList={navList} hideMenu={this.props.hideMenu} />

              <div className="menu-large-btns">
                <Link
                  to={paths.advocates.myprofile}
                  className="btn -simple menu-large-btn"
                  onClick={this.props.hideMenu}
                >
                  Мой профиль
                </Link>
                <a
                  href={paths.common.signout}
                  className="btn -simple menu-large-btn -loguot"
                  onClick={this.props.hideMenu}
                >
                  Выход
                </a>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  static propTypes = {
    user: PropTypes.object.isRequired,
    toggleMenu: PropTypes.func.isRequired,
    hideMenu: PropTypes.func.isRequired,
  };
}
